module.exports = __webpack_public_path__ + "media/login-video.91d9cdf0.mp4";